/**
 * @file 单纯staking时的确认内容
 */
import { DirectiondownIcon } from '@bfe/moly-icons';
import { useFm } from '@web3/base-hooks';
import { useCoinInfoContext } from '@/hooks/useCoinInfo';
import { useAccountInfoContext } from '@/hooks/useAccountInfo';
import { BigNumber } from 'bignumber.js';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { UnstakeCoinInfoStore } from '@/types/unstake';
import { formatUSDYield } from '@/utils/num';
import { useSolLoss } from '@/containers/operation/account/unstakeInfo/hooks';
import styles from './index.module.scss';

interface Props {
  unstakeAmount: string;
  selectCoinList: string[];
  unstakeCoinAmountStore: UnstakeCoinInfoStore;
}

export const UnstakeContent = (props: Props) => {
  const { coinInfoStore } = useCoinInfoContext();
  const { unstakeAmount, selectCoinList, unstakeCoinAmountStore } = props;
  const { poolInfo } = usePoolInfoContext();
  const { accountInfo } = useAccountInfoContext();
  const { lpCoinDetail } = accountInfo;
  const fm = useFm();

  const { isSolLoss = false } = useSolLoss(
    selectCoinList,
    unstakeCoinAmountStore
  );

  return (
    <>
      <div className={styles.container}>
        <div className={styles.stakingTitleArea}>
          <div className={styles.stakingTitleLabel}>{fm('fromProtocol')}</div>
        </div>
        <div className={styles.currentToken}>
          <div className={styles.currentTokenLeft}>
            <img
              src={lpCoinDetail?.iconNightUrl}
              className={styles.currentTokenIcon}
            />
            <div className={styles.currentTokenSymbol}>
              {lpCoinDetail?.symbol ?? ''}
            </div>
          </div>
          <div>
            <div className={styles.currentTokenAmount}>{unstakeAmount}</div>
            <div className={styles.currentTokenValue}>
              {lpCoinDetail?.price
                ? formatUSDYield(
                    BigNumber(unstakeAmount)
                      .times(lpCoinDetail?.price)
                      .toString()
                  )
                : ''}
            </div>
          </div>
        </div>
        <DirectiondownIcon className={styles.arrowDown} />
        <div>
          <div className={styles.stakingTitleArea}>
            <div className={styles.stakingTitleLabel}>{fm('received')}</div>
          </div>
          {selectCoinList.map((contractAddress, index) => {
            const coinInfo =
              coinInfoStore[`${poolInfo.chainCode}${contractAddress}`];
            const { amount } = unstakeCoinAmountStore[contractAddress] || {};
            return (
              <div className={styles.currentToken} key={index}>
                <div className={styles.currentTokenLeft}>
                  <img
                    src={coinInfo.iconNightUrl}
                    className={styles.currentTokenIcon}
                  />
                  <div className={styles.currentTokenSymbol}>
                    {coinInfo?.symbol}
                  </div>
                  {isSolLoss ? (
                    <div className={styles.loss}>{fm('damage')}</div>
                  ) : null}
                </div>
                <div>
                  <div className={styles.currentTokenAmount}>{amount}</div>
                  <div className={styles.currentTokenValue}>
                    {coinInfo.price
                      ? formatUSDYield(
                          BigNumber(amount).times(coinInfo.price).toString()
                        )
                      : ''}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
